var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrizinicLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 416.68 113.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -140.94,
    y1: 752.93,
    x2: -72.73,
    y2: 826.38,
    gradientTransform: "matrix(-1, 0, 0, 1, -34.16, -723.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#565fa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ec0775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fac111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -108.36,
    y1: 724.43,
    x2: -40.15,
    y2: 797.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -115.55,
    y1: 731.12,
    x2: -47.35,
    y2: 804.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -98.21,
    y1: 715,
    x2: -30,
    y2: 788.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -87.16,
    y1: 704.76,
    x2: -18.96,
    y2: 778.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -78.33,
    y1: 696.55,
    x2: -10.13,
    y2: 770,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -100.15,
    y1: 716.81,
    x2: -31.94,
    y2: 790.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -129.98,
    y1: 744.51,
    x2: -61.77,
    y2: 817.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 417.82,
    y1: 803.88,
    x2: -80.12,
    y2: 771.14,
    gradientTransform: "translate(0 -723.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b5338e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#d2237d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#fac111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 418,
    y1: 801.2,
    x2: -79.94,
    y2: 768.46,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 418.13,
    y1: 799.11,
    x2: -79.81,
    y2: 766.36,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 418.34,
    y1: 795.89,
    x2: -79.6,
    y2: 763.15,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 418.58,
    y1: 792.31,
    x2: -79.36,
    y2: 759.56,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 418.74,
    y1: 789.91,
    x2: -79.2,
    y2: 757.17,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 418.9,
    y1: 787.36,
    x2: -79.04,
    y2: 754.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -242.55,
    y1: 818.26,
    x2: -230.14,
    y2: 831.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -297.64,
    y1: 818.27,
    x2: -285.24,
    y2: 831.64,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 76.85,
    cy: 61.89,
    r: 10.77,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.08,
    cy: 20.68,
    r: 5.94,
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.87,
    cy: 21.34,
    r: 2.49,
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.39,
    cy: 10.75,
    r: 3.08,
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.56,
    cy: 11.05,
    r: 4.27,
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.18,
    cy: 9.89,
    r: 2.42,
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16,39.94A7.22,7.22,0,0,1,25,42.48a7.11,7.11,0,0,1,.27-3.6,3.15,3.15,0,0,0-.69-3.18l-1.1-1.15A2.45,2.45,0,0,0,21,33.83a4.68,4.68,0,0,1-5.71-3.35h0a2.21,2.21,0,0,0-.08-.35,4.71,4.71,0,1,1,9.21-2,2.21,2.21,0,0,1,0,.25,2.76,2.76,0,0,1,.06.4,5,5,0,0,1-.08,1.39,2.62,2.62,0,0,0,.63,2.38l1.05,1.1a3.21,3.21,0,0,0,3.43.73,7,7,0,0,1,3.61-.35A7.19,7.19,0,0,1,39.16,39.94Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.83,60.7A36,36,0,0,0,57.88,31.31l.1.18a5.82,5.82,0,0,1,1-.24,6.18,6.18,0,1,1-3.28,1.69l-.07-.12A6.13,6.13,0,0,1,48,31.93l-1.19-1.2a7.28,7.28,0,0,1-2.13-6.25,8.11,8.11,0,0,0,.06-2.2A7.86,7.86,0,1,0,36.23,31a8.45,8.45,0,0,0,2.3-.13A7.2,7.2,0,0,1,45.09,33l1.08,1a6.11,6.11,0,0,1,.8,7.71,36,36,0,1,0,65.82,19Zm-66.2-5.64a2.76,2.76,0,1,1,2.8-2.76,2.77,2.77,0,0,1-2.8,2.76ZM76,82.85A20.92,20.92,0,0,1,55.93,61.13a21.47,21.47,0,0,1,.9-5.28,5.07,5.07,0,1,1,4.73-8.17A20.93,20.93,0,1,1,76,82.85Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21,86.68V36.92h21.68c5.93,0,10.51,1.27,13.76,3.84s4.87,6.16,4.87,10.8a13.82,13.82,0,0,1-2.67,8.71,20,20,0,0,1-8.14,5.79l11.66,20.62H149L137.91,67.06h-6.18V86.68Zm11.52-29H143a6.75,6.75,0,0,0,4.73-1.49,5.46,5.46,0,0,0,1.6-4.19,5.49,5.49,0,0,0-1.6-4.2A6.71,6.71,0,0,0,143,46.3H131.7Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,86.68V36.92h11.5V86.68Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.32,86.68v-10L210.2,47H186.46V36.92h37.46V47L199.4,76.58h25.87v10.1Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.55,61.79A24.61,24.61,0,0,1,235,43.42a27.05,27.05,0,0,1,37.39,0,24.67,24.67,0,0,1,7.47,18.37A26.43,26.43,0,0,1,235,80.17,24.59,24.59,0,0,1,227.55,61.79Zm36.61,11a14.9,14.9,0,0,0,4.19-11,14.88,14.88,0,0,0-4.19-11,15.1,15.1,0,0,0-20.9,0,14.89,14.89,0,0,0-4.2,11,14.91,14.91,0,0,0,4.2,11A15.1,15.1,0,0,0,264.16,72.79Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,86.68V36.92h11.52l18.2,28.22a41,41,0,0,1,2.13,3.91V36.92h11.23V86.68H318.54l-18.2-28.44c-1-1.8-1.76-3.1-2.13-3.91V86.68Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,86.68V36.92h11.52V86.68Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,61.79q-.15-11.31,7.42-18.65a25.28,25.28,0,0,1,18.73-7.22,26.19,26.19,0,0,1,13.72,3.52A20.48,20.48,0,0,1,406.32,49l-9.59,6.68q-4.28-9.09-13-9.1a13.6,13.6,0,0,0-10.17,4.23,15.1,15.1,0,0,0-4.12,11,15.06,15.06,0,0,0,4.16,10.92A13.72,13.72,0,0,0,383.8,77a13,13,0,0,0,7.78-2.31,20.85,20.85,0,0,0,5.87-7.15l9.31,6.69q-4.54,7.11-9.88,10.27a25.19,25.19,0,0,1-13.08,3.16q-11.24.14-18.62-7.18T357.92,61.79Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.48,105.13V94.9h3.74a3.59,3.59,0,0,1,2.33.68,2.12,2.12,0,0,1,.87,1.75,2.27,2.27,0,0,1-.48,1.44,2.69,2.69,0,0,1-1.22.88,2.5,2.5,0,0,1,2.08,2.53,2.62,2.62,0,0,1-1,2.13,3.89,3.89,0,0,1-2.52.82Zm1.22-6h2.45c1.37,0,2.06-.53,2.06-1.59a1.42,1.42,0,0,0-.55-1.21,2.38,2.38,0,0,0-1.51-.4H120.7Zm0,4.88h2.4a3.12,3.12,0,0,0,1.81-.48,1.87,1.87,0,0,0,.21-2.64,2.08,2.08,0,0,0-.21-.21,3,3,0,0,0-1.81-.48h-2.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.57,105.13V94.9h4.07a3.44,3.44,0,0,1,2.4.8,2.59,2.59,0,0,1,.9,2,2.75,2.75,0,0,1-.65,1.86,3.27,3.27,0,0,1-1.81,1l2.53,4.51h-1.36l-2.52-4.43H129.8v4.43Zm1.23-5.49h2.7c1.47,0,2.21-.61,2.21-1.83S134,96,132.5,96h-2.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.68,105.13l4.09-10.23H142l4.09,10.23h-1.3l-1.17-3h-4.5l-1.17,3Zm2.88-4.06h3.68l-1.56-4a8.11,8.11,0,0,1-.28-.78,8.11,8.11,0,0,1-.28.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,105.13V94.9h1.28l4.93,7.65c.21.36.36.62.44.8V94.9h1.18v10.23h-1.27l-4.93-7.66c-.21-.36-.36-.63-.44-.8v8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52,105.13V94.9h2.82a5.15,5.15,0,0,1,3.77,1.38,5.56,5.56,0,0,1,0,7.47,5.24,5.24,0,0,1-3.77,1.38Zm1.23-1.09h1.55a4.06,4.06,0,0,0,2.94-1,4,4,0,0,0-2.94-7h-1.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.34,105.13V94.9h1.23v10.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,105.13V94.9h1.29l4.93,7.65c.21.36.35.62.43.8V94.9h1.19v10.23h-1.28l-4.92-7.66c-.21-.36-.36-.63-.44-.8v8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,100a5,5,0,0,1,1.48-3.77,4.63,4.63,0,0,1,3.56-1.55,4.72,4.72,0,0,1,2.54.65A4.3,4.3,0,0,1,190,97.2l-.93.67a3.59,3.59,0,0,0-3.35-2.11A3.4,3.4,0,0,0,183,97a4.12,4.12,0,0,0-1.12,3,4.41,4.41,0,0,0,1,3,3.42,3.42,0,0,0,2.66,1.19,3,3,0,0,0,2.21-.9,3.88,3.88,0,0,0,1-2.3h-3.59v-1H190v5.13h-.83l-.35-1.77a3.58,3.58,0,0,1-3.29,2,4.54,4.54,0,0,1-3.52-1.52A5.34,5.34,0,0,1,180.66,100Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,105.13,215.28,94.9h1.24l2,7.62c.13.49.22.87.26,1.12q.06-.35.27-1.14l2-7.6h1.32l2,7.6c.13.53.22.91.26,1.14a7.27,7.27,0,0,1,.26-1.12l2.05-7.62h1.24l-2.88,10.23H224l-2.27-8.66-2.26,8.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.49,105.13V94.9h6.39V96h-5.16v3.3h4.75v1.07h-4.75V104h5.2v1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,105.13V94.9h3.74a3.59,3.59,0,0,1,2.33.68,2.12,2.12,0,0,1,.87,1.75,2.34,2.34,0,0,1-.47,1.44,2.82,2.82,0,0,1-1.22.88,2.5,2.5,0,0,1,2.07,2.53,2.62,2.62,0,0,1-1,2.13,3.89,3.89,0,0,1-2.52.82Zm1.23-6h2.44c1.37,0,2.06-.53,2.06-1.59a1.4,1.4,0,0,0-.55-1.17,2.41,2.41,0,0,0-1.52-.4H239Zm0,4.88h2.39a3.08,3.08,0,0,0,1.82-.48,1.89,1.89,0,0,0,.18-2.67,1.53,1.53,0,0,0-.18-.18,2.94,2.94,0,0,0-1.82-.48h-2.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.33,105.13V94.9h2.82a5.15,5.15,0,0,1,3.77,1.38,5.56,5.56,0,0,1,0,7.47,5.24,5.24,0,0,1-3.77,1.38Zm1.23-1.09h1.55a4.06,4.06,0,0,0,2.94-1,4,4,0,0,0-2.94-7h-1.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,105.13V94.9h1.23v10.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2,100a5.09,5.09,0,0,1,1.47-3.77,4.67,4.67,0,0,1,3.57-1.55,4.78,4.78,0,0,1,2.53.65,4.39,4.39,0,0,1,1.72,1.85l-.93.67a3.59,3.59,0,0,0-3.35-2.11A3.45,3.45,0,0,0,286.54,97a4.2,4.2,0,0,0-1.12,3,4.48,4.48,0,0,0,1,3,3.42,3.42,0,0,0,2.66,1.19,2.93,2.93,0,0,0,2.2-.9,3.88,3.88,0,0,0,1-2.3h-3.6v-1h4.82v5.13h-.83l-.35-1.77a3.54,3.54,0,0,1-3.29,2,4.52,4.52,0,0,1-3.51-1.52A5.32,5.32,0,0,1,284.2,100Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,105.13V94.9h1.22v10.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.43,105.13V96h-3.16V94.9h7.54V96h-3.15v9.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,105.13l4.09-10.23h1.26l4.09,10.23h-1.3l-1.17-3h-4.5l-1.17,3Zm2.88-4.06h3.68l-1.56-4a8.11,8.11,0,0,1-.28-.78,8.11,8.11,0,0,1-.28.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.76,105.13V94.9H317V104h5.21v1.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.64,102.17l1.09-.57q.56,2.67,3,2.67a2.91,2.91,0,0,0,1.82-.56,1.72,1.72,0,0,0,.69-1.35,1.5,1.5,0,0,0-.68-1.31,5,5,0,0,0-2.07-.75c-2.23-.42-3.34-1.39-3.34-2.93a2.35,2.35,0,0,1,1-1.93,3.84,3.84,0,0,1,2.45-.74,4,4,0,0,1,2.34.66,3.58,3.58,0,0,1,1.38,1.84l-1,.57A3,3,0,0,0,330.49,96a3.22,3.22,0,0,0-.53.25,1.37,1.37,0,0,0-.61,1.17,1.42,1.42,0,0,0,.69,1.22,6,6,0,0,0,2.13.75c2.21.42,3.31,1.4,3.32,2.94a2.76,2.76,0,0,1-1.05,2.19,4.06,4.06,0,0,1-2.68.88,4.14,4.14,0,0,1-2.73-.88A3.92,3.92,0,0,1,327.64,102.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,100a5.21,5.21,0,0,1,1.41-3.83,5,5,0,0,1,7.07,0h0a5.91,5.91,0,0,1,0,7.66,5,5,0,0,1-7.07,0h0A5.22,5.22,0,0,1,336.64,100Zm7.63,3a5,5,0,0,0,0-6.11,3.64,3.64,0,0,0-5.35,0,4.94,4.94,0,0,0,0,6.11,3.49,3.49,0,0,0,2.67,1.17,3.53,3.53,0,0,0,2.68-1.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,105.13V94.9h1.23V104h5.21v1.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.72,101.55V94.9H357v6.58a2.63,2.63,0,0,0,5.24.46,3.53,3.53,0,0,0,0-.46V94.9h1.22v6.65a3.65,3.65,0,0,1-1,2.78,4.38,4.38,0,0,1-5.58,0A3.66,3.66,0,0,1,355.72,101.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,105.13V96h-3.16V94.9h7.55V96H369.1v9.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,105.13V94.9H375v10.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,100a5.21,5.21,0,0,1,1.41-3.83,5,5,0,0,1,7.07,0h0a5.91,5.91,0,0,1,0,7.66,5,5,0,0,1-7.07,0h0A5.22,5.22,0,0,1,376.77,100Zm7.63,3a4.94,4.94,0,0,0,0-6.11,3.64,3.64,0,0,0-5.14-.21,2.08,2.08,0,0,0-.21.21,5,5,0,0,0,0,6.11,3.64,3.64,0,0,0,5.14.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.48,105.13V94.9h1.28l4.93,7.65a7.74,7.74,0,0,1,.44.8V94.9h1.18v10.23H395l-4.92-7.66a8.94,8.94,0,0,1-.44-.8v8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.07,102.17l1.09-.57c.38,1.78,1.36,2.67,3,2.67a2.83,2.83,0,0,0,1.82-.56,1.73,1.73,0,0,0,.7-1.35,1.53,1.53,0,0,0-.68-1.31,5,5,0,0,0-2.07-.75c-2.23-.42-3.34-1.39-3.35-2.93a2.35,2.35,0,0,1,1-1.93A3.88,3.88,0,0,1,402,94.7a4,4,0,0,1,2.34.66,3.51,3.51,0,0,1,1.37,1.84l-1,.57a2.72,2.72,0,0,0-2.77-2,2.64,2.64,0,0,0-1.59.43,1.37,1.37,0,0,0-.61,1.17,1.44,1.44,0,0,0,.68,1.22,6.08,6.08,0,0,0,2.14.75c2.21.42,3.31,1.4,3.32,2.94a2.76,2.76,0,0,1-1.05,2.19,4.06,4.06,0,0,1-2.68.88,4.17,4.17,0,0,1-2.74-.88A4,4,0,0,1,398.07,102.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.94,
    cy: 100.87,
    r: 1.96,
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.04,
    cy: 100.87,
    r: 1.96,
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrizinicLogo);
export default __webpack_public_path__ + "static/media/orizinic-logo.247493f121ad090b85eadd4502ccc5ed.svg";
export { ForwardRef as ReactComponent };